import { PlusIcon, TrashIcon } from '@f8n/icons';
import { styled } from '@f8n-frontend/stitches';
import { forwardRef } from 'react';

import {
  ContentBlockControls,
  ContentBlockProps,
  HOVER_BUTTON_CLASSNAME,
  HOVER_BUTTON_SELECTOR,
} from 'components/ContentBlock';
import Button from 'components/base/Button';

import { Toolbar } from './StoryToolbar';

type AddControlProps =
  | { controls: 'ADD'; onAdd(): void; canAdd: boolean }
  | { controls: 'NONE' };

type StoryContentBlockProps = Pick<ContentBlockProps, 'children' | 'onRemove'> &
  AddControlProps & {
    isFocused: boolean;
  };

// TODO (storytelling): forward ref for focus capture
export const StoryContentBlock = forwardRef<
  HTMLDivElement,
  StoryContentBlockProps
>(function StoryContentBlock(props, ref) {
  return (
    <StoryContentBlockWrapper tabIndex={0} ref={ref}>
      <ContentControlsPositioner>
        <div
          style={{
            transform: 'translateY(-50%)',
          }}
        >
          <ContentControlButton
            className={HOVER_BUTTON_CLASSNAME}
            icon="standalone"
            onClick={props.onRemove}
          >
            <TrashIcon />
          </ContentControlButton>
        </div>

        {props.controls === 'ADD' && props.canAdd && (
          <div
            style={{
              top: '50%',
              position: 'absolute',
              transform: 'translateY(-50%)',
            }}
          >
            <ContentControlButton
              className={HOVER_BUTTON_CLASSNAME}
              icon="standalone"
              onClick={() => {
                props.onAdd();
              }}
            >
              <PlusIcon />
            </ContentControlButton>
          </div>
        )}
      </ContentControlsPositioner>
      {props.children}
    </StoryContentBlockWrapper>
  );
});

const StoryContentBlockWrapper = styled('div', {
  transition: 'all $2 $ease',

  outline: 'none',

  [`${ContentBlockControls}`]: {
    right: 0,
    transform: 'translateX(50%)',
    height: '100%',
  },

  [`${Toolbar.Root}`]: {
    opacity: 0,
    transition: 'opacity $2 $ease',
  },

  [HOVER_BUTTON_SELECTOR]: {
    opacity: 0,
    transition: 'opacity $2 $ease',
  },

  '@hover': {
    margin: 0,
    [`${ContentBlockControls}`]: {
      right: '$$spacing',
    },

    '&:hover': {
      [HOVER_BUTTON_SELECTOR]: {
        opacity: 1,
      },
      [`${Toolbar.Root}`]: {
        opacity: 1,
      },
    },
  },

  '@noHover': {
    [HOVER_BUTTON_SELECTOR]: {
      display: 'none',
    },
  },
});

const ContentControlsPositioner = styled('div', {
  position: 'absolute',
  right: 0,
  top: 0,
  transform: 'translateX(50%)',
  /**
   * this is the height minus the caption
   */
  height: 'calc(100% - 26.5px)',
});

export const ContentControlButton = styled(Button, {});

ContentControlButton.defaultProps = {
  size: 0,
  variant: 'secondary',
};
